import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { TriggerForm } from "~/components/form/health-profile/TriggerForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.trigger;

export default function EditTrigger() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const trigger = findMedical(type, id);

    if (!trigger) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="triggers">
            <TriggerForm trigger={trigger} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
